import { render, staticRenderFns } from "./PractitionerInternAdd.vue?vue&type=template&id=18b57ac6&scoped=true"
import script from "./PractitionerInternAdd.vue?vue&type=script&lang=js"
export * from "./PractitionerInternAdd.vue?vue&type=script&lang=js"
import style0 from "./PractitionerInternAdd.vue?vue&type=style&index=0&id=18b57ac6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b57ac6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18b57ac6')) {
      api.createRecord('18b57ac6', component.options)
    } else {
      api.reload('18b57ac6', component.options)
    }
    module.hot.accept("./PractitionerInternAdd.vue?vue&type=template&id=18b57ac6&scoped=true", function () {
      api.rerender('18b57ac6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/practitionerIntern/PractitionerInternAdd.vue"
export default component.exports